import React from 'react';
import radium from 'radium';
import { ThemeContext } from '../theme/Theme.jsx';

import './FormElements.scss';

interface LeoLabelProps {
	label: string,
	for: string,
	id: string,
	error?: boolean,
	warn?: boolean,
	className?: string,
	
}

const defaultProps = {
	className : ''
};

function LeoLabel(propsIn: LeoLabelProps) {
	const props = {...defaultProps, ...propsIn};
	const context = React.useContext(ThemeContext);
	
	const style = {
		color: context.themeManager.value('form-select', 'color', 'fg-color-form-element'),
	};
	const errStyle = {
		color: context.themeManager.value('form-select', 'color', 'fg-color-form-element'),
	};
	const warnStyle = {
		color: context.themeManager.value('form-select', 'color', 'fg-color-form-element'),
	};
	
	function determineStyle() {
		if (props.error) {
			return errStyle;
		} else if (props.warn) {
			return warnStyle;
		}
		return style;
	}
	
	return (<label  style={determineStyle()}
			htmlFor={props.for}
			className={props.className + ' leo__label'}
			id={props.id}>{props.label}
		</label>
	);
}

export default radium(LeoLabel);
